import type { IconData } from '@stacksjs/iconify-core'

export const buttonPlayCircleRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 43.5c10.77 0 19.5-8.73 19.5-19.5S34.77 4.5 24 4.5S4.5 13.23 4.5 24S13.23 43.5 24 43.5M47.5 24c0 12.979-10.521 23.5-23.5 23.5S.5 36.979.5 24S11.021.5 24 .5S47.5 11.021 47.5 24M16.796 13.794c1.135-.703 2.567-.835 3.991-.268c1.564.623 3.602 1.552 6.212 2.938c2.465 1.31 4.417 2.484 5.937 3.481c1.52.998 2.328 2.504 2.328 4.057c0 1.552-.807 3.059-2.328 4.056s-3.472 2.171-5.937 3.48c-2.61 1.387-4.648 2.316-6.212 2.94c-1.424.566-2.856.434-3.991-.269c-1.13-.7-1.902-1.924-2.105-3.422c-.243-1.79-.441-4.079-.441-6.785s.198-4.996.44-6.786c.204-1.498.976-2.722 2.106-3.422\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default buttonPlayCircleRemix
